<script setup lang="ts">
import { Card } from '@/components/ui/card'
import { store } from '@/store/store'
import { watch, ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Loader2 } from 'lucide-vue-next';
import { getParam, choosePatient } from '@/lib/utils';
import AppointmentCard from '@/components/profile/AppointmentCard.vue';

const route = useRoute();
const router = useRouter();
const loader = ref(true);

function selectPatient (id: string) {
    choosePatient(id);
    router.push({ name: 'profile', params: { domain: getParam(route), patientId: id } });
}

onMounted(() => {
    if (store.members.length === 1) {
        selectPatient(store.members[0].pid);
    }
});

watch(() => store.members, (members) => {
    if (members.length === 1) { 
        selectPatient(members[0].pid);
        return;
    }
    if (members.length) {
        loader.value = false;
    }
}, { immediate: true });
</script>

<template>
    <h2 class="title" v-if="store.members.length">Profiles</h2>
    <Loader2 v-if="loader" class="w-10 h-10 mx-auto mt-10 animate-spin" />
    <div v-else class="mt-5 grid gap-3">
        <Card v-for="patient in store.members" class="cursor-pointer p-3 min-h-13 rounded-xl"
            @click="selectPatient(patient.pid)">
            <div class="flex justify-between items-center">
                <div class="grid gap-1">
                    <div class="font-medium text-gray-900">{{ patient.name + ' ' + patient.family }}</div>
                    <div class="text-sm text-gray-400 capitalize" v-if="patient.relationship">{{ patient.relationship }}
                    </div>
                    <div class="text-sm text-gray-400 capitalize" v-if="patient.hin">Health Number: {{ patient.hin }}
                    </div>
                </div>
                <i class="isax isax-arrow-right-1 text-xl shrink-0 text-gray-400"></i>
            </div>
            <div v-if="patient.upcoming_appointment.appID" class="mt-4 border-t border-gray-300 pt-2 border-dashed">
                <div class="text-sm text-gray-400 leading-relaxed mb-2 font-medium">Upcoming Appointment:</div>
                <AppointmentCard :appointment="patient.upcoming_appointment" class="shadow-none" @click.stop />
            </div>
        </Card>
        <RouterLink :to="{name: 'add', params: { domain: getParam(route) }}"
            class="flex items-center p-3 border border-dashed rounded-xl border-gray-300 font-medium text-secondary min-h-13 mb-10">
            <i class="isax isax-add text-xl mr-2.5"></i>
            Add Someone in My Care
        </RouterLink>
    </div>
</template>
